import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Global axios interceptor — suppress 401 error toasts (token expiry)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired — clear and let auth redirect handle it
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("metricsChecked");
      // Only reload if not already on the landing page
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
      // Return a silent rejection so page-level catch blocks don't show toast
      return Promise.reject({ _handled401: true });
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
